<template>
  <div>
    <!-- Start - Mobile-->
    <div class="service-summary">
      <PackageSummary
        class="package-summary"
        :joining-tenant="joiningTenant"
        :inline-editing="false"
        :hide-unwanted-products="true"
      >
        <template v-slot:summary-header>
          <h2 class="content-panel__title">Your Utility Package</h2>
        </template>
        <template v-slot:summary-footer>
          <div class="price-info-mobile">
            <span>For A Total Of</span>
            <section class="price-display">
              <strong class="weekly-price-old" v-if="nonDiscountedPpppw">
                £{{ nonDiscountedPpppw }}
              </strong>
              <strong class="weekly-price">£{{ ppppw }}</strong>
            </section>
            <span class="pppw">per person per week</span>
            <span class="collected-monthly"
              >collected monthly by direct debit</span
            >
            <monthly-price-info class="collected-monthly" />
          </div>

          <slot></slot>
        </template>
      </PackageSummary>

      <div class="vl" />

      <PackageSchedule
        class="package-schedule"
        :tenancy-start-date="tenancyStartDate"
        :tenancy-end-date="tenancyEndDate"
        :first-payment-date="firstPaymentDate"
        :broadband-installation-date="broadbandDate"
      />
    </div>

    <!-- Start - Mobile-->
    <!-- Start - Desktop-->
    <div class="price-info-desktop">
      <span class="price-info">
        For a total of
        <span class="price-old" v-if="nonDiscountedPpppw">
          £{{ nonDiscountedPpppw }}
        </span>
        <span v-if="nonDiscountedPpppw">&nbsp;</span>
        <span class="price" data-testid="summary-price">£{{ ppppw }}</span> per
        person per week
      </span>
      <span class="collected-dd">collected monthly by Direct Debit.</span>
      <monthly-price-info class="collected-dd" />
    </div>

    <!-- End - Desktop-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import PackageSummary from "@/components/PackageSummary";
import PackageSchedule from "@/components/PackageSchedule";
import MonthlyPriceInfo from "@/components/MonthlyPriceInfo.vue";

export default {
  name: "ServiceSummary",
  components: {
    MonthlyPriceInfo,
    PackageSchedule,
    PackageSummary,
  },
  data() {
    return {
      toggleWeeklyPrice: true,
    };
  },
  props: {
    joiningTenant: {
      type: Boolean,
      required: false,
      default: false,
    },
    ppppm: {
      type: [Number, String],
      required: true,
    },
    ppppw: {
      type: [Number, String],
      required: true,
    },
    nonDiscountedPpppw: {
      type: [Number, String],
      required: false,
    },
    nonDiscountedPpppm: {
      type: [Number, String],
      required: false,
    },
    tenancyStartDate: {
      type: String,
      required: true,
    },
    tenancyEndDate: {
      type: String,
      required: true,
    },
    firstPaymentDate: {
      type: String,
      required: true,
    },
    broadbandDate: {
      type: String,
      required: false,
    },
    discountDescription: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState(["agent"]),
  },
};
</script>

<style lang="scss" scoped>
.service-summary {
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  grid-template-rows: auto;
  grid-auto-flow: row;
  grid-row-gap: 1rem;
  grid-column-gap: 3rem;

  border-radius: $border-radius-large;
  margin-bottom: $spacing-large;

  justify-content: space-between;

  @include media("<medium") {
    padding: 0;
    background-color: transparent;

    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);
    grid-column-gap: 0;
    grid-row-gap: 0;
  }

  .package-summary {
    background: $white;

    .price-info-mobile {
      text-align: center;
      margin: $spacing-small 0;

      @include media(">=medium") {
        display: none;
      }

      section.price-display {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.3em;
      }

      span,
      strong {
        display: block;
      }

      .weekly-price-old {
        text-decoration: line-through;
        color: #afafaf;
        font-size: 16px;
      }

      .weekly-price {
        font-size: 21px;
        color: $brand-green;
      }

      .pppw {
        font-size: $small-font-size;
      }

      .collected-monthly {
        font-size: 10px;
      }
    }

    @include media("<medium") {
      padding: 0 $spacing-small;
      border-radius: $border-radius-medium;
      box-shadow: $brand-box-shadow;

      .content-panel__title {
        margin: $spacing-small 0;
      }
    }
  }

  .package-schedule {
    background: $white;

    @include media("<medium") {
      order: 3;

      box-shadow: $brand-box-shadow;
      border-radius: $border-radius-medium;
      margin: $spacing-medium 0 0 0;
      justify-content: space-evenly;
      padding: $spacing-small 0 $spacing-small $spacing-small;
    }
  }

  .vl {
    position: relative;
    height: 100%;
    top: 2.5%;
    width: 0;
    border: 1px solid #224b8126;
    border-radius: 1px;

    @include media("<medium") {
      display: none;
    }
  }
}

.price-info-desktop {
  font-size: 18px;
  text-align: center;

  @include media("<medium") {
    display: none;
  }

  .price-info {
    display: block;
  }

  .price-old {
    text-decoration: line-through;
    color: #afafaf;
    font-weight: $font-bold;
  }

  .price {
    font-weight: $font-bold;
    color: $brand-green;
  }

  .collected-dd {
    display: block;
    font-size: 12px;
  }
}
</style>
